<div class="loginLoadingImage" *ngIf="showLoading">
   <div class="loginLoadingImageAnimation"></div>
</div>